type Args = {
	readonly kind: 'contact' | 'staff';
	readonly id: number;
	readonly label: string;
};

/** One participant of a fused entry, whichever side it comes from — a contact or a member of staff. */
class InternalInterviewParticipantView {
	readonly kind: 'contact' | 'staff';
	readonly id: number;
	readonly label: string;

	constructor(parts: Args) {
		this.kind = parts.kind;
		this.id = parts.id;
		this.label = parts.label;

		Object.freeze(this);
	}
}

export default InternalInterviewParticipantView;
